module.exports = __webpack_public_path__ + "img/RegistrationCert-2026.b5a01e1e.jpg";